import React from "react";

import { Box, Typography, Card, CardContent } from '@mui/material';


export default function InfoCard({ icon: IconComponent, title, note, description }) {
    const isImageIcon = typeof IconComponent === "string";

    return (
        <Card sx={{ mb: 2, borderRadius: 4 }} elevation={0}>
            <CardContent>
                <Box sx={{ display: 'flex', alignItems: 'center', mb: 1 }}>
                    {isImageIcon ? (
                        <Box
                            component="img"
                            src={IconComponent}
                            alt="icon"
                            sx={{ width: 18, height: 18, mr: 1 }}
                        />
                    ) : (
                        <IconComponent sx={{ fontSize: 18, mr: 1 }} />
                    )}
                    <Typography
                        sx={{
                            fontWeight: 550,
                            fontSize: "clamp(12px, 2.5vh, 16px)",
                            lineHeight: '20px'
                        }}
                    >
                        {title}
                    </Typography>
                </Box>
                {note && <Typography
                    sx={{
                        fontWeight: 550,
                        fontSize: "clamp(8px, 2.5vh, 12px)",
                        lineHeight: '20px',
                        color: '#2200BB'
                    }}
                >
                    {note}
                </Typography>
                }
                <Typography
                    sx={{
                        fontWeight: 400,
                        fontSize: "clamp(10px, 2.5vh, 14px)",
                        lineHeight: '20px',
                        color: 'text.secondary'
                    }}
                >
                    {description}
                </Typography>
            </CardContent>
        </Card>
    );
}